var module = angular.module('octopusApp.projects');

module.run(function(pluginRegistry, actionExecutionLocations) {
  pluginRegistry.registerDeploymentAction("Octopus.AzureServiceFabricPowerShell", function() {
    return {
      executionLocation: actionExecutionLocations.alwaysOnServer,
      canChooseRoles: true,
      canHaveChildren: function() { return true; },
      canBeChild: true,
      hasPackages: function(action) { return false; },

            summaryTemplateUrl: "areas/projects/actions/azure_service_fabric_powershell/Octopus.AzureServiceFabricPowerShell_summary.html",
            editTemplateUrl: "areas/projects/actions/azure_service_fabric_powershell/Octopus.AzureServiceFabricPowerShell_edit.html",

            preLink: function (scope) {
                scope.app = {
                };
                
                if (!scope.action.Properties['Octopus.Action.ServiceFabric.SecurityMode']) {
                    scope.action.Properties['Octopus.Action.ServiceFabric.SecurityMode'] = "Unsecure";
                }
                // TODO: markse - Note that this default can be removed once Azure adds support for ClientCertificate credential types.
                if (!scope.action.Properties['Octopus.Action.ServiceFabric.AadCredentialType']) {
                    scope.action.Properties['Octopus.Action.ServiceFabric.AadCredentialType'] = "UserCredential";
                }
            },

            editLink: function (scope) {
                scope.$watch('action.Properties', function (nv) {
                    if (nv != null) {
                        if (!nv['Octopus.Action.Script.ScriptSource']) {
                            nv['Octopus.Action.Script.ScriptSource'] = "Inline";
                        }

                        var isRunFromPackage = nv['Octopus.Action.Script.ScriptSource'] === 'Package';
                        if (isRunFromPackage) {
                            nv['Octopus.Action.Script.ScriptBody'] = null;
                        } else {
                            nv['Octopus.Action.Script.ScriptFileName'] = null;
                            nv['Octopus.Action.Package.FeedId'] = null;
                            nv['Octopus.Action.Package.PackageId'] = null;
                        }
                    }
                }, true);
            }
        };
    });
});




//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/actions/azure_service_fabric_powershell/Octopus.AzureServiceFabricPowerShell.js
// module id = 564059387284782
// module chunks = 1